// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__-mtQm","form":"styles_form__3wwcG"};